export class JobForm {
    url?: string;
    title?: string;

    static fromJson(fields): JobForm {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
